import { font, mixins } from '../../../styles';

const getBorderColor = (props) => {
  if (props.focused) {
    if (props.color === 'default') {
      return props.theme.primary.base;
    } else if (props.color === 'white') {
      return props.theme.white[50];
    }

    return props.theme[props.color].base;
  }

  if (props.color === 'default') {
    return props.theme.default.base;
  } else if (props.color === 'white') {
    return props.theme.white.darker;
  }

  return props.theme[props.color].darker;
}

const getBorderRadius = (props) => {
  switch (props.size) {
    case 'large':
      return props.rounded ? 32 : 8;
    default:
      return props.rounded ? 32 : 4;
  }
}

const getBorderWidth = (props) => {
  switch (props.size) {
    case 'large':
      return 3;
    case 'small':
    case 'default':
    default:
      return 2;
  }
};

const getFontSize = (props) => {
  switch (props.size) {
    case 'large':
      return font.getFontSize(1.5);
    case 'small':
      return font.getFontSize(0.75);
    case 'default':
    default:
      return font.getFontSize(0.875);
  }
};

const getHeight = (props) => {
  switch (props.size) {
    case 'large':
      return 48;
    case 'small':
      return 24;
    case 'default':
    default:
      return 32;
  }
};

const getLineHeight = props => `${(getHeight(props) - (getBorderWidth(props) * 2))}px`;

const getMinWidth = (props) => {
  if (props.isFullWidth) {
    return 'auto';
  }

  return props.size === 'large' ? 300 : 200;
};

const getPaddingButton = (props) => {
  switch (props.size) {
    case 'large':
      return 48;
    default:
      return props.rounded ? 32 : 16;
  }
};

const getPaddingIcon = (props) => {
  switch (props.size) {
    case 'large':
      return 48;
    default:
      return props.rounded ? 32 : 24;
  }
};

const getPadding = (props) => {
  switch (props.size) {
    case 'large':
      return props.rounded ? 24 : 12;
    default:
      return props.rounded ? 16 : 8;
  }
};

const getPaddingForDirection = (direction) => (props) => {
  if (props[`${direction}Button`]) {
   return getPaddingButton(props);
  }

  if (props[`${direction}Icon`]) {
   return getPaddingIcon(props);
  }

  return getPadding(props);
};

const getPaddingLeft = getPaddingForDirection('left');
const getPaddingRight = getPaddingForDirection('right');

const getWidthIcon = (props) => {
  switch (props.size) {
    case 'large':
      return 48;
    default:
      return 24;
  }
};

export const Container = props => ({
  overflow: 'hidden',
  position: 'relative',
  display: 'flex',
  height: getHeight(props),
  minWidth: getMinWidth(props),

  borderWidth: getBorderWidth(props),
  borderStyle: 'solid',
  borderColor: getBorderColor(props),
  borderRadius: getBorderRadius(props),

  fontSize: getFontSize(props),
  lineHeight: getLineHeight(props),

  opacity: props.disabled ? 0.5 : 1,

  ...props.glamStyle,
});

export const Placeholder = props => ({
  // ...mixins.fillToParent,
  // position: 'absolute',
  display: 'flex',

  paddingLeft: getPaddingLeft(props),
  paddingRight: getPaddingRight(props),

  color: props.theme[props.textColor].base,
  fontStyle: 'italic',

  opacity: 0.75,
  userSelect: 'none',
  visibility: props.isVisible ? 'visible' : 'hidden',
});

const buttonRules = props => ({
  zIndex: 10,
  position: 'absolute',
  top: -(getBorderWidth(props)),
  color: props.focused ? props.theme[props.color].base : props.theme[props.color].dark,
});

export const LeftButton = props => ({
  ...buttonRules(props),
  left: -2,
});

export const RightButton = props => ({
  ...buttonRules(props),
  right: -2,
});

const iconRules = props => ({
  ...buttonRules(props),
  top: 0,
  width: getWidthIcon(props),
  textAlign: 'center',
});

export const LeftIcon = props => ({
  ...iconRules(props),
  left: 0,
});

export const RightIcon = props => ({
  ...iconRules(props),
  right: 0,
});

export const Input = props => ({
  ...mixins.fillToParent,
  position: 'absolute',
  display: 'block',

  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: getPaddingLeft(props),
  paddingRight: getPaddingRight(props),

  backgroundColor: 'transparent',
  border: 'none',

  color: props.theme[props.textColor].base,

  appearance: 'none',

  '&:focus': {
    outline: 'none',
  },
});



// WEBPACK FOOTER //
// ./src/components/ui/TextField/styles.js